import React from 'react'
import Box from '@mui/material/Box';

function Save({ widgetStyle, widgetProps }) {
    return (
        <Box sx={[widgetStyle ?? {}]}>
            <Box component={'img'} src={widgetProps.imageUrl ?? 'https://hyper-active.com/assets/images/logo.png'} sx={{ width: '100%', objectFit: widgetProps.objectFit ?? 'cover', height: '100%' }} />
        </Box>
    )
}

export default React.memo(Save);